let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("acCHK")).then(() => parcelRequire('c1upw'));